<template>
  <div class="animated fadeIn">
    <b-button
      type="button"
      size="sm"
      variant="primary"
      :disabled="disabled"
      v-on:click="addDonation"
    ><i class="fa fa-plus"></i> Add
    </b-button>
  </div>
</template>
<script>
  import {RepositoryFactory} from "../../../services/repositories/RepositoryFactory";
  import {Donation} from "../../../models/Donation";
  import router from "../../../router";

  const DonationRepo = RepositoryFactory.get('donation');

  export default {
    name: 'donation-add-button',
    props: {
      donation: {
        type: Object,
        default: new Donation(),
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      addDonation() {
        this.$emit('click')
        let postData = {
          amount: this.donation.amount,
          customer: {
            name: this.donation.person.name,
            surname: this.donation.person.surname,
            email: this.donation.person.email
          },
          subscribeToNewsLetter: this.donation.subscribeToNewsLetter
        }
        DonationRepo.createDonation(postData)
          .then(
            response => (
              router.push({name: 'donation', params: {donationId: response.data.data.id}})
            )
          )
      },
    },
  }
</script>
